module.exports = __webpack_public_path__ + "img/Workbook.ecfb15d6.jpg";